import { jsx as _jsx } from "react/jsx-runtime";
import { TextField } from '@mui/material';
export const Select = ({ children, ...props }) => {
    return (_jsx(TextField, { ...props, SelectProps: { native: true }, fullWidth: true, select: true, autoComplete: 'off', children: children }));
};
